module.exports = __webpack_public_path__ + "static/media/role-master.75b2e035.svg";